/**
 * Paleta de estilos do bloco (@eeacms/volto-block-style) só para quem pode.
 *
 * Cópia do `BlockStyleWrapperEdit` do add-on com uma única regra a mais: o
 * botão da paleta (ícone de pintura no alto da aba Bloco) e o formulário de
 * estilos só existem quando `@mpf-permissoes` confirma `block_styles` — por
 * padrão administradores; um perfil de acesso libera para a Coorweb. Decisão
 * editorial de 03/10/2026 (AB#11159): "não compete ao usuário comum esse tipo
 * de ajuste". Os estilos já gravados continuam sendo aplicados ao bloco
 * (`StyleWrapperView`), para quem edita não desfazer o que outra pessoa fez.
 *
 * O add-on importa este arquivo por caminho relativo, então a pasta de
 * customização sozinha não o alcança: a troca é feita no webpack, em
 * `razzle.extend.js` (NormalModuleReplacementPlugin). Esta pasta mantém a
 * convenção do Volto e cobre quem importar pelo caminho completo.
 */
import React from 'react';
import { useSelector } from 'react-redux';
import {
  StyleWrapperEdit,
  StyleWrapperView,
} from '@eeacms/volto-block-style/StyleWrapper';
import { Portal } from 'react-portal';
import themeSVG from '@plone/volto/icons/theme.svg';
import Icon from '@plone/volto/components/theme/Icon/Icon';
import config from '@plone/volto/registry';

import { podeEstilizarBlocos } from 'volto-ministerio-publico-federal/helpers/Permissoes';

// For blocks, store the style data in data.styles, then
// adapt the data.styles.[align,size,...] info to default data.align, data.size, etc.

const BlockStyleWrapperEdit = (props) => {
  const { selected, block, data = {}, onChangeBlock, manage } = props;
  const [isVisible, setIsVisible] = React.useState(false);
  const permissoes = useSelector((state) => state.mpfPermissoes?.data);
  const podeEstilizar = podeEstilizarBlocos(permissoes);
  const visible =
    selected &&
    podeEstilizar &&
    (config.settings.layoutOnlyBlockStyles ? manage : true);

  const tabsNode =
    __CLIENT__ &&
    document.querySelector(
      '#sidebar > .sidebar-container > .tabs-wrapper > .formtabs',
    );

  const triggerButton = (
    <Portal node={tabsNode}>
      <div className="open-styles-button">
        <button
          onClick={(e) => {
            e.nativeEvent.stopImmediatePropagation();
            setIsVisible(true);
          }}
          title={
            props.type
              ? `Paleta de estilos do bloco ${props.type}`
              : 'Paleta de estilos'
          }
        >
          <Icon name={themeSVG} size="18px" />
        </button>
      </div>
    </Portal>
  );

  return (
    <>
      {visible ? triggerButton : ''}
      {podeEstilizar && (
        <StyleWrapperEdit
          {...props}
          isVisible={isVisible}
          setIsVisible={setIsVisible}
          data={{
            ...data?.styles,
            ...(data.align ? { align: data.align } : {}),
            ...(data.size ? { size: data.size } : {}),
          }}
          blockData={data}
          choices={[]}
          onChangeValue={(id, value) =>
            onChangeBlock(block, {
              ...data,
              ...(id === 'align' ? { align: value } : {}),
              ...(id === 'size' ? { size: value } : {}),
              ...(id === 'customId' ? { id: value } : {}),
              styles: {
                ...data?.styles,
                [id]: value,
              },
            })
          }
        ></StyleWrapperEdit>
      )}
      <StyleWrapperView mode="edit" {...props} styleData={data.styles || {}} />
    </>
  );
};

export default BlockStyleWrapperEdit;
